export default __webpack_public_path__ + "static/media/683.73149a87.png";